import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';

import moment from 'moment';
import { dateFormatter } from '../../../common/components/Utils/renderField/renderReadField'

const url = 'reporte';

const LOADER_RVEN = 'LOADER_RVEN';
const SET_DATA_RVEN = 'SET_DATA_RVEN';
const SET_GRAFICAMOVIMIENTOS_RVEN = 'SET_GRAFICAMOVIMIENTOS_RVEN';
const SET_GRAFICAALERTA_RVEN = 'SET_GRAFICAALERTA_RVEN';

const SET_DATAMOVIMIENTOS_RVEN = 'SET_DATAMOVIMIENTOS_RVEN';

const SET_PAGE_RVEN = 'SET_PAGE_RVEN';
const SET_UPDATE_DATA_RVEN ='SET_UPDATE_DATA_RVEN';
const SET_BUSCADOR_RVEN = 'SET_BUSCADOR_RVEN';
const SET_FILTRO_RVEN = 'SET_FILTRO_RVEN';

const SET_FAREA_RINV = 'SET_FAREA_RINV';
const SET_FMOVI_RINV = 'SET_FMOVI_RINV';

const SET_TAB_RINV = 'SET_TAB_RINV';

const SET_STARTDATE_RVEN = 'SET_STARTDATE_RVEN';
const SET_ENDDATE_RVEN = 'SET_ENDDATE_RVEN';
const SET_VENCIMIENTO = 'SET_VENCIMIENTO';

function obtenerFechas(dateStart, dateEnd){
    let params = {};
    if (dateStart) {
        try {
            dateStart = dateStart.format("YYYY-MM-D");
        } catch (error) {
            dateStart = dateStart;
        }
        params["fecha_inicial"] = dateStart;
    }
    if (dateEnd) {
        try {
            dateEnd = dateEnd.format("YYYY-MM-D");
        } catch (error) {
            dateEnd = dateEnd;
        }
        params["fecha_final"] = dateEnd;
    }
    return params;
}
const listar_alertas = (page = 1) => (dispatch, getStore) => {
    dispatch({ type: LOADER_RVEN, cargando: true });
    const store = getStore();
    const search = store.rvencimiento.buscador;
    const filtro_area = store.rvencimiento.filtro_area;
    const vencimiento = store.rvencimiento.vencimiento;
    const filtro_movimiento = store.rvencimiento.filtro_movimiento;

    let dateStart = store.rvencimiento.dateStart;
    let dateEnd = store.rvencimiento.dateEnd

    let params = { page, search };

    if(filtro_area){
        params['filtro_area'] = filtro_area.id;
    }
    if(store.rvencimiento.vencimiento) {
        params['vencimiento'] = vencimiento.value;
    }

    params = {
        ...params,
        ...obtenerFechas(dateStart, dateEnd)
    }

    api.get(`inventario/getAlertaInventario`, params).catch((error) => {
        dispatch({ type: LOADER_RVEN, cargando: false });
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if (data) {
            dispatch({ type: SET_DATA_RVEN, data: data });
            dispatch({type: SET_PAGE_RVEN,page: page});
        }
        dispatch({ type: LOADER_RVEN, cargando: false });
    })
};

//////////////////////////////////////////////////////////////////////////
/// Sección para graficas
//////////////////////////////////////////////////////////////////////////
const getGraficaAlerta = (page = 1) => (dispatch, getStore) => {
    dispatch({ type: LOADER_RVEN, cargando: true });
    const store = getStore();
    const search = store.rvencimiento.buscador;
    const filtro_area = store.rvencimiento.filtro_area;
    const filtro_movimiento = store.rvencimiento.filtro_movimiento;

    let dateStart = store.rvencimiento.dateStart;
    let dateEnd = store.rvencimiento.dateEnd

    let params = { page, search };

    if(filtro_area){
        params['filtro_area'] = filtro_area.id;
    }
    if(filtro_movimiento){
        params['filtro_movimiento'] = filtro_movimiento.value;
    }

    params = {
        ...params,
        ...obtenerFechas(dateStart, dateEnd)
    }

    api.get(`inventario/getGrafica_alertas`, params).catch((error) => {
        dispatch({ type: LOADER_RVEN, cargando: false });
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if (data) {
            dispatch({ type: SET_GRAFICAALERTA_RVEN, grafica_alerta: data });
        }
        dispatch({ type: LOADER_RVEN, cargando: false });
    })
};
const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_RVEN, buscador: search});
    dispatch(listar_alertas());
    dispatch(getGraficaAlerta());
};
const setFiltroArea = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FAREA_RINV, filtro_area: filtro});
    dispatch(listar_alertas());
    dispatch(getGraficaAlerta());
};
const setFiltroMovimientos = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FMOVI_RINV, filtro_movimiento: filtro});
    dispatch(listar_movimientos());
}

const setDateStart = (date) => (dispatch, getStore) => {
    const store = getStore();
    dispatch({ type: SET_STARTDATE_RVEN, dateStart: date });
    dispatch(listar_alertas());
}
const setDateEnd = (date) => (dispatch, getStore) => {
    const store = getStore();
    dispatch({ type: SET_ENDDATE_RVEN, dateEnd: date });
    dispatch(listar_alertas());
}
const setTab = (tab) => (dispatch, getStore) => {
    dispatch({
        type: SET_TAB_RINV,
        toggleTab: tab
    })
}
const setFiltroVencimiento = (vencimiento) => (dispatch) => {
    dispatch({ type: SET_VENCIMIENTO, vencimiento });
    dispatch(listar_alertas());
}
export const actions = {
    listar_alertas,
    search,
    setFiltroMovimientos,
    setFiltroArea,
    setDateEnd,
    setDateStart,
    getGraficaAlerta,
    setTab,
    setFiltroVencimiento
};
export const reducer = {
    [LOADER_RVEN]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_RVEN]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_RVEN]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_RVEN]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_RVEN]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_DATAMOVIMIENTOS_RVEN]: (state, { data_movimiento }) => {
        return {...state, data_movimiento }
    },
    [SET_FAREA_RINV]: (state, { filtro_area }) => {
        return {...state, filtro_area }
    },
    [SET_FMOVI_RINV]: (state, { filtro_movimiento }) => {
        return {...state, filtro_movimiento }
    },
    [SET_STARTDATE_RVEN]: (state, { dateStart }) => {
        return {...state, dateStart }
    },
    [SET_ENDDATE_RVEN]: (state, { dateEnd }) => {
        return {...state, dateEnd }
    },
    [SET_TAB_RINV]: (state, { toggleTab }) => {
        return {...state, toggleTab }
    },
    [SET_GRAFICAALERTA_RVEN]: (state, { grafica_alerta }) => {
        return {...state, grafica_alerta }
    },
    [SET_VENCIMIENTO] : (state, { vencimiento}) => {
        return {...state, vencimiento}
    }
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_: null,
    filtro_area: null,
    filtro_movimiento: null,
    updateData: {},
    dateStart: moment().subtract(7, 'days'),
    dateEnd: moment(),
    toggleTab: 'alertas',
    grafica_alerta: [],
    vencimiento: null
};
export default handleActions(reducer, initialState)
